module.exports = __webpack_public_path__ + "static/img/no_star.f6763481.svg";